import {
  CLOSE_CURRENT_MODAL,
  HANDLE_PROMOTIONS,
  OPEN_MODAL,
  CREATE_ACCOUNT,
  CLOSE_CREATE_ACCOUNT
} from '@Header/Modals/ducks/types';
import { DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER } from '../../../constants/modalNames';
import initialState from './state';

export const modalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL: {
      if (state.modals.length < 1 && !state.currentModal) {
        return {
          ...state,
          currentModal: action.modalName
        };
      }
      return {
        ...state,
        modals: [...state.modals, action.modalName]
      };
    }
    case CLOSE_CURRENT_MODAL:
      return {
        ...state,
        modals: state.modals.slice(1),
        currentModal: state.modals.slice(0, 1)[0] || null
      };
    case HANDLE_PROMOTIONS:
      return {
        ...state,
        modals: [...state.modals, ...action.payload],
        currentModal: state.currentModal || action.payload[0]
      };
    case CLOSE_CREATE_ACCOUNT:
      return {
        ...state,
        createAccountDetails: {
          onSuccess: null,
          onError: null
        }
      };
    case CREATE_ACCOUNT:
      return {
        ...state,
        createAccountDetails: {
          callerIdentifier: action?.callerIdentifier ?? DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER,
          modalTitle: action?.modalTitle ?? null,
          onSuccess: action?.onSuccess ?? null,
          onError: action?.onError ?? null
        }
      };
    default:
      return state;
  }
};
